'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRef, useState } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';

const ShareLink = props => {
  const {
    anchorId,
    trackingSource
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["anchorId", "trackingSource"]);

  const inputRef = useRef(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const copyToClipboard = () => {
    if (inputRef.current) {
      inputRef.current.value = `${window.location.origin}${window.location.pathname}${window.location.search}#${anchorId}`;
      inputRef.current.type = 'text';
      inputRef.current.select();
      document.execCommand('copy');
      inputRef.current.type = 'hidden';
      setTooltipOpen(true);
    }
  };

  const handleShareLinkClick = () => {
    getUsageTracker().track('linkClick', {
      name: 'share-link',
      trackingSource,
      url: `${window.location.origin}${window.location.pathname}${window.location.search}#${anchorId}`
    });
    copyToClipboard();
  };

  return /*#__PURE__*/_jsxs("div", Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(UIPopover, {
      content: /*#__PURE__*/_jsx("div", {
        className: "m-all-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.productPages.linkCopied"
        })
      }),
      open: tooltipOpen,
      onOpenChange: () => setTooltipOpen(false),
      autoPlacement: false,
      placement: "right",
      children: /*#__PURE__*/_jsxs(UILink, {
        onClick: handleShareLinkClick,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "share",
          size: "xs",
          className: "m-right-1",
          style: {
            verticalAlign: 'middle'
          }
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.planBuilder.productPages.shareThisPrice"
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("input", {
        id: "calculator-hidden-link-input",
        ref: inputRef,
        type: "hidden"
      })
    })]
  }));
};

export default ShareLink;